import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./login.style.css";
import logo from "../../assets/logo.png";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";

function LoginComponent({ email, password, error, onEmailChange, onPasswordChange, onSubmit }) {
    const { t } = useTranslation();

    return (
        <div className="login-container">
            <LanguageSwitcher variant="auth" />

            <main className="login-box">
                <img
                    src={logo}
                    alt="Ferreira Systeembouw Logo"
                    className="login-logo"
                    loading="eager"
                />

                <h1 className="text-2xl font-bold text-center mb-4">{t('login.title')}</h1>

                {error && (
                    <div className="error-message mb-4" role="alert" aria-live="polite">
                        {error}
                    </div>
                )}

                <form onSubmit={onSubmit} className="login-form" noValidate>
                    <div className="form-group">
                        <label htmlFor="email-input" className="form-label">
                            {t('login.email')}
                        </label>
                        <input
                            type="email"
                            id="email-input"
                            name="email"
                            className="form-input"
                            placeholder={t('login.email')}
                            value={email}
                            onChange={onEmailChange}
                            required
                            aria-required="true"
                            aria-invalid={error ? "true" : "false"}
                            autoComplete="email"
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password-input" className="form-label">
                            {t('login.password')}
                        </label>
                        <input
                            type="password"
                            id="password-input"
                            name="password"
                            className="form-input"
                            placeholder={t('login.password')}
                            value={password}
                            onChange={onPasswordChange}
                            required
                            aria-required="true"
                            aria-invalid={error ? "true" : "false"}
                            autoComplete="current-password"
                        />
                    </div>

                    <p className="forgot-password text-right mb-4">
                        <Link to="/forgot-password" className="text-primary">
                            {t('login.forgotPassword')}
                        </Link>
                    </p>

                    <div className="form-actions">
                        <button
                            type="submit"
                            className="btn btn-submit w-full"
                            aria-label={t('login.login')}
                        >
                            {t('login.login')}
                        </button>
                    </div>
                </form>

                <p className="register text-center mt-5">
                    {t('login.noAccount')}{' '}
                    <Link to="/register" className="text-primary font-semibold">
                        {t('login.register')}
                    </Link>
                </p>
            </main>
        </div>
    );
}

LoginComponent.propTypes = {
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    error: PropTypes.string,
    onEmailChange: PropTypes.func.isRequired,
    onPasswordChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default LoginComponent;
